<mat-form-field
  class="form-control"
  hideRequiredMarker="true"
  [ngClass]="{ 'is-invalid-field': isInvalid }"
  [tooltip]="tooltip"
>
  <mat-select [formControl]="control" [multiple]="multiple" [placeholder]="placeholder">
    <div *ngIf="searchable" class="search-option px-3">
      <mat-icon class="search-icon" matPrefix aria-label="Search Icon">search</mat-icon>
      <input
        type="text"
        class="search-input"
        matInput
        [placeholder]="placeholder"
        [formControl]="searchControl"
        (keydown.space)="$event.stopPropagation()"
      />
      <button mat-icon-button>
        <mat-icon
          *ngIf="searchControl?.value"
          matSuffix
          class="clear-icon"
          aria-label="Clear"
          (click)="clearSearch($event)"
          >clear</mat-icon
        >
      </button>
    </div>
    <mat-option *ngIf="hasAllOption && !searchControl?.value" [value]="'all'">All</mat-option>
    <ng-container *ngIf="data.length > 0 && isString(data[0]); else objectOptions">
      <mat-option *ngFor="let item of data" [value]="item" [disabled]="control.value?.includes('all')">{{
        item
      }}</mat-option>
    </ng-container>
    <ng-template #objectOptions>
      <mat-option *ngFor="let item of data" [value]="item[valueProperty]" [disabled]="control.value?.includes('all')">{{
        item[displayProperty]
      }}</mat-option>
    </ng-template>
  </mat-select>
</mat-form-field>
<div *ngIf="isInvalid" class="error-message">
  <div>{{ errorMessage }}</div>
</div>
